import React, { useState } from 'react';
import { Button, Dropdown } from '../../components';
import { DownOutlined } from '@ant-design/icons';

const CLOUDS = {
    AWS: 'aws',
    Azure: 'azure',
    'Azure Local': 'azure_local',
    'Google Cloud': 'gcp',
    'HPE VM Essentails': 'hpe_vme',
    'Nutanix NC2': 'nc2',
    OpenShift: 'openshift',
    vSphere: 'rivermeadow_standalone',
    OpenStack: 'openstack',
    'Hyper-V': 'hyperv',
};

const AdvancedSettingsDropdown = () => {
    const [selectedLabel, setSelectedLabel] = useState('AWS');

    const menuItems = Object.entries(CLOUDS).map(([key, dataType]) => ({
        key: key.toLowerCase(),
        label: (
            <a
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                    setSelectedLabel(key);
                    window.handleAdvancedSettingsMenuChange(dataType);
                }}
            >
                {key}
            </a>
        ),
    }));

    return (
        <div className="cloud-type-dropdown">
            <label>Cloud Type</label>
            <Dropdown menu={{ items: menuItems }} placement="bottomLeft">
                <Button>
                    {selectedLabel} <DownOutlined />
                </Button>
            </Dropdown>
        </div>
    );
};

export default AdvancedSettingsDropdown;
